import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, MapPin, Target, History, Heart, Info } from 'lucide-react';
import BackButton from '../components/buttons/BackButton';
import Card from '../components/Card/Card';
import SectionHeader from '../components/SectionHeader/SectionHeader';
import Button from '../components/buttons/Button';
import './About.css';

const About = () => {
    const navigate = useNavigate();

    return (
        <div className="about-page">
            <BackButton to="/guide" />

            {/* Header Section */}
            <header className="about-header-main">
                <div className="header-content">
                    <img src={`${process.env.PUBLIC_URL}/icon.png`} alt="Voxia" className="logo" />
                    <h1>À propos de voxia et GBM Medical SA</h1>
                    <p className="about-subtitle">
                        Votre assistant médical privé, conçu par des médecins pour des médecins
                    </p>
                </div>
            </header>

            <div className="settings-container">
                
                {/* Mission Section */}
                <Card className="card-large">
                    <SectionHeader icon={Target} title="Notre mission" />
                    <div className="about-section">
                        <p>
                            voxia (anciennement Clarity) a été créé par GBM Medical SA, une entreprise suisse fondée par deux médecins et un ingénieur. 
                            Notre objectif est d'aider les médecins dans leurs tâches administratives en leur offrant un accès facilité à des modèles 
                            d'intelligence artificielle (IA) personnalisables et auto-apprenants.
                        </p>
                        <p>
                            Nous savons combien les tâches administratives peuvent être chronophages et parfois frustrantes. 
                            C'est pourquoi nous avons développé voxia, votre assistant médical privé, conçu pour alléger votre charge 
                            de travail et vous permettre de vous concentrer sur ce qui compte vraiment : vos patients.
                        </p>
                    </div>
                </Card>

                {/* History Section */}
                <Card className="card-large">
                    <SectionHeader icon={History} title="Histoire" />
                    <div className="about-section">
                        <p>
                            L'un de nos fondateurs a créé pour lui même de petites applications basées sur des grands modèles de langage, 
                            afin de lui faciliter sa vie de médecin assistant en médecine interne. Lorsqu'il a découvert la puissance de 
                            son outil, il a voulu le démocratiser et l'offrir à tous les médecins, tout en étant compatible avec les 
                            exigences suisses de protection des données médicales.
                        </p>
                        <p>
                            Notre but est de créer un service entièrement hébergé en Suisse.
                        </p>
                    </div>
                </Card>
                
                {/* Values Section */}
                <Card className="card-large">
                    <SectionHeader icon={Heart} title="Nos valeurs" />
                    <div className="about-section">
                        <p>
                            Chez GBM Medical SA, en tant que médecins, nous vivons au quotidien les défis auxquels les professionnels 
                            de la santé sont confrontés. Voxia est spécialement entraîné pour transcrire vos dictées vocales avec 
                            rapidité et précision, vous fournissant des rapports en quelques secondes.
                        </p>
                        <p>
                            Plus vous utilisez voxia, plus il devient performant, apprenant à comprendre et à s'adapter à votre 
                            manière de parler et d'écrire.
                        </p>
                        <p>
                            Nous souhaitons garantir la protection de vos données et celles de vos patients, c'est pourquoi nous 
                            utilisons des serveurs situés en Suisse et que nous ne conservons aucun audio que vous nous envoyez.
                        </p>
                    </div>
                </Card>

                {/* Contact Section */}
                <Card className="card-large">
                    <SectionHeader icon={Info} title="Contact" />
                    <div className="about-section">
                        <p>
                            Vous avez une requête de fonctionnalité à ajouter ? N'hésitez pas à nous faire part de vos suggestions et retours.
                        </p>
                        
                        <div className="contact-cards">
                            {/* Email Contact */}
                            <div className="contact-card">
                                <div className="contact-card-icon">
                                    <Mail size={24} />
                                </div>
                                <div className="contact-card-content">
                                    <p>Contactez-nous pour toute question ou suggestion</p>
                                    <Button
                                        variant="primary"
                                        type="default"
                                        size="default"
                                        icon={Mail}
                                        onClick={() => navigate('/contact')}
                                    >
                                        Nous contacter
                                    </Button>
                                </div>
                            </div>
                            
                            {/* Address Contact */}
                            <div className="contact-card">
                                <div className="contact-card-icon">
                                    <MapPin size={24} />
                                </div>
                                <div className="contact-card-content">
                                    <h4>Adresse</h4>
                                    <div className="address-info">
                                        <p className="company-name">GBM Medical SA</p>
                                        <p>116 chemin des Bûcherons</p>
                                        <p>1234 Vessy</p>
                                        <p>Suisse</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default About;